import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGenericAPIMutation } from 'hooks/mutations/useGenericAPIMutation';
import {
    MailingAddress,
} from '../../../pages/ClientOverview/pages/ClientConnections/components/NewConnections/constants';
import { notification } from '../../../ui-library';

type ICallBackProps = (...args: any) => Promise<any> | Promise<void>;

export const useUpdateConnectionMailingAddress = () => {
    const { t } = useTranslation();
    const [inProgress, setInProgress] = useState<boolean>(false);

    const {
        mutateAsync: handleConnectionAddressUpdate,
    } = useGenericAPIMutation();

    const updateContactGroupAddress = useCallback(async (groupId: string, address: MailingAddress, callback?: ICallBackProps): Promise<void> => {
        try {
            setInProgress(true);
            await handleConnectionAddressUpdate({
                service: 'customClientService',
                API: 'updateContactGroupAddress',
                payload: { contactGroupId: groupId, mailingAddress: address },
                invalidateQueryKeys: ['getData_getContactGroupDetails', 'getData_getContactGroupAddresses'],
            });

            if (callback) {
                await callback(parseInt(groupId, 10));
            }

            notification.open({
                content: t('contactGroups.addressUpdatedSuccessfully'),
                type: 'success',
            });
        } catch (err: any) {
            notification.open({
                content: `${t('contactGroups.somethingWentWrong')} ${err.message}`,
                type: 'error',
            });
        } finally {
            setInProgress(false);
        }
    }, [handleConnectionAddressUpdate, t]);

    return {
        inProgress,
        updateContactGroupAddress,
    };
};
